import { readEnv } from "@repo/helpers";
import { cs as csJSON } from "@repo/ui";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export enum Language {
    CS = "cs",
}

// do wee need plurals? if yes use this: https://github.com/i18next/i18next-intervalPlural-postProcessor
i18n.use(initReactI18next).init({
    resources: {
        [Language.CS]: {
            translations: { ...csJSON },
        },
    },
    debug: readEnv("GATSBY_VERSION") === "local",
    lng: Language.CS,
    fallbackLng: Language.CS,
    preload: [Language.CS],
    ns: "translations",
    defaultNS: "translations",
    interpolation: {
        escapeValue: false,
    },
});
